import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../api/axios';
import { Plus, X } from 'lucide-react';

const roleBadge = r => {
  const map = { ADMIN:'badge-red', MANAGER:'badge-amber', ACCOUNTANT:'badge-blue', OPERATOR:'badge-muted' };
  return <span className={`badge ${map[r]||'badge-muted'}`}>{r}</span>;
};

const EMPTY = { email:'', full_name:'', role:'OPERATOR', phone:'', password:'' };

export default function SettingsPage() {
  const [users, setUsers]         = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm]           = useState(EMPTY);
  const [saving, setSaving]       = useState(false);
  const [error, setError]         = useState('');
  const [msg, setMsg]             = useState('');

  const load = () => {
    setLoading(true);
    api.get('/auth/users/').then(r => setUsers(r.data.results||[])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async e => {
    e.preventDefault(); setSaving(true); setError('');
    try {
      await api.post('/auth/users/', form);
      setShowModal(false); setForm(EMPTY); load();
      setMsg('User created!'); setTimeout(() => setMsg(''), 3000);
    } catch (err) {
      const errs = err.response?.data?.errors;
      setError(errs ? JSON.stringify(errs) : 'Failed to create user.');
    } finally { setSaving(false); }
  };

  return (
    <Layout
      title="Settings"
      subtitle="User accounts and system configuration"
      actions={<button className="btn btn-primary" onClick={() => setShowModal(true)}><Plus size={14}/>Add User</button>}
    >
      {msg && <div className="success-box">{msg}</div>}
      <div className="card">
        <div className="card-header"><div className="card-title">System Users</div></div>
        {loading ? <div className="loading"><div className="spinner"/>Loading...</div> :
          users.length === 0 ? <div className="empty-state"><p>No users found.</p></div> :
          <div className="table-wrap">
            <table>
              <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Phone</th><th>Status</th></tr></thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    <td style={{ fontWeight:600, color:'var(--text-primary)' }}>{u.full_name}</td>
                    <td>{u.email}</td>
                    <td>{roleBadge(u.role)}</td>
                    <td>{u.phone||'—'}</td>
                    <td>{u.is_active ? <span className="badge badge-green">Active</span> : <span className="badge badge-red">Inactive</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div><h3>Add New User</h3></div>
              <button onClick={() => setShowModal(false)} style={{ background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer', fontSize:18 }}>×</button>
            </div>
            <form onSubmit={handleCreate}>
              <div className="modal-body">
                {error && <div className="error-box">{error}</div>}
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Full Name *</label>
                    <input className="form-input" required value={form.full_name} onChange={e => setForm({...form,full_name:e.target.value})}/>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email *</label>
                    <input className="form-input" type="email" required value={form.email} onChange={e => setForm({...form,email:e.target.value})}/>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Role</label>
                    <select className="form-input" value={form.role} onChange={e => setForm({...form,role:e.target.value})}>
                      <option value="OPERATOR">Operator</option>
                      <option value="ACCOUNTANT">Accountant</option>
                      <option value="MANAGER">Manager</option>
                      <option value="ADMIN">Admin</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Phone</label>
                    <input className="form-input" value={form.phone} onChange={e => setForm({...form,phone:e.target.value})}/>
                  </div>
                  <div className="form-group" style={{ gridColumn:'1/-1' }}>
                    <label className="form-label">Password *</label>
                    <input className="form-input" type="password" required minLength={8} value={form.password} onChange={e => setForm({...form,password:e.target.value})}/>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving?'Creating...':'Create User'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
